@if (record.$meta.hasChildren && isMobile) {
  <mat-divider class="opacity-50" />
  <ul>
    @for (child of record['children']; track child.label) {
      <li
        (navigationRecordAction)="navigationRecordAction.emit($event)"
        [appNavigationRecord]="child"
        [isMobile]="isMobile"
      ></li>
    }
  </ul>
  <mat-divider class="opacity-50" />
} @else {
  <ng-template #recordContent>
    <div
      class="justify-start flex relative after:content-[''] transition-all"
      [ngClass]="{
        'lg:text-zinc-700 hover:text-orange-500': !record.$meta.isRootRecord,
        'lg:font-bold lg:uppercase lg:text-white lg:text-sm hover:after:absolute hover:after:-bottom-1 hover:after:left-0 hover:after:w-full hover:after:h-0.5 hover:after:bg-[linear-gradient(90deg,#ff742e,#ffbb2c)]':
          record.$meta.isRootRecord,
        'after:absolute after:-bottom-1 after:left-0 after:w-full after:h-0.5 after:bg-[linear-gradient(90deg,#ff742e,#ffbb2c)]':
          record.$meta.isRootRecord && !isMobile && isActive(),
        '!text-orange-500':
          (!record.$meta.isRootRecord || isMobile) && isActive(),
      }"
    >
      @if (isMobile && record.$meta.parent; as parent) {
        @if (parent.alias || parent.label; as prefix) {
          <strong>{{ prefix }}:</strong>
        }
      }
      @if (record.prefixIcon) {
        <mat-icon
          class="!text-inherit"
          [ngClass]="{
            '!mr-0': !record.label,
            '!mr-1': record.label,
          }"
        >
          {{ record.prefixIcon }}
        </mat-icon>
      }
      {{ record.label }}
    </div>
  </ng-template>

  <mat-menu #childMenu="matMenu" xPosition="after">
    <ul>
      @for (child of record['children']; track child.label) {
        <li
          (navigationRecordAction)="navigationRecordAction.emit($event)"
          [appNavigationRecord]="child"
          [isMobile]="isMobile"
        ></li>
      }
    </ul>
  </mat-menu>

  @if (record['pathname']?.startsWith('http')) {
    <a
      mat-menu-item
      class="w-full h-full cursor-pointer text-base lg:text-sm"
      [ngClass]="{
        'lg:!px-2 rounded-md': record.$meta.isRootRecord,
      }"
      [target]="'_blank'"
      [attr.aria-label]="record['ariaLabel']"
      [href]="record['pathname']"
      rel="noopener"
    >
      <ng-container *ngTemplateOutlet="recordContent" />
    </a>
  } @else {
    <a
      mat-menu-item
      class="w-full h-full cursor-pointer text-base lg:text-sm"
      [ngClass]="{
        'lg:!px-2 rounded-md': record.$meta.isRootRecord,
        '!bg-orange-500/10 hover:!bg-orange-500/20':
          (!record.$meta.isRootRecord || isMobile) && isActive(),
      }"
      [matMenuTriggerFor]="
        record.$meta.hasChildren && !isMobile ? childMenu : null
      "
      (click)="onClick($event)"
      routerLinkActive="active-link"
      [attr.aria-label]="record['ariaLabel']"
      [routerLinkActiveOptions]="{ exact: true }"
      [routerLink]="
        record['pathname']?.startsWith('@') ? null : record['pathname']
      "
      [queryParams]="record['params']"
    >
      <ng-container *ngTemplateOutlet="recordContent" />
    </a>
  }
}
